import { useNavigate } from 'react-router-dom';
import { PageTitle } from '@/components';
import { useCreateQuestion } from '@/services';
import { FaqForm } from './FaqForm';

const CreateFaq = () => {
	const navigate = useNavigate();

	const onBack = () => navigate(-1);

	const { mutate, isPending } = useCreateQuestion(() => onBack());

	const onSubmit = (body: Questions.Create) => mutate(body);

	return (
		<section className="space-y-4 px-4 py-8">
			<PageTitle
				text="FAQ"
				// type='faq'
			/>
			<FaqForm
				onBack={() => onBack()}
				onSubmit={onSubmit}
				isSubmitting={isPending}
			/>
		</section>
	);
};

export { CreateFaq };
